/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GradientRadialClosestCorner(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GradientRadialClosestCorner',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".6","fillRule":"evenodd","clipRule":"evenodd","d":"M14 2H5V1h10v14H1V5h1v9h12V2z","fill":"currentColor"}),createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M2 1H1v3h1V2.707L4.414 5.12c.186-.28.427-.52.707-.706L2.71 2H4V1H2z","fill":"currentColor"}),createElement('circle', {"cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(5 5)","fill":"currentColor"}),createElement('path', {"opacity":".4","fillRule":"evenodd","clipRule":"evenodd","d":"M2 5v6.19A6.5 6.5 0 0011.19 2H5v.88l1.146 1.145a2.5 2.5 0 11-2.12 2.12L2.878 5H2z","fill":"currentColor"}))
}
